// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-notes-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.details-notes-modal {
  background: white;
  padding: 2rem;
  border-radius: 0.8rem;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.modal-header h2 {
  font-size: 3.2rem;
  color: #2c3948;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
}

.criteres-container {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.critere-block {
  display: flex;
  gap: 1rem;
}

.critere-colone-1 {
  width: 40%;
  padding: 0 2rem 2rem;
}

.critere-colone-2 {
  width: 60%;
}

.critere-titre {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: column;
  height: 100%;
}

.critere-titre h3 {
  color: #2c3948;
  font-size: 2rem;
  font-weight: 600;
  width: 100%;
}

.note-container {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
}

.note {
  font-size: 3.6rem;
  font-weight: bold;
  color: #2c3948;
}

.separator {
  font-size: 2rem;
  color: #2c3948;
}

.total {
  display: flex;
  gap: 2rem;
  align-items: center;
  font-size: 1.6rem;
  color: #6b7280;
  font-weight: 500;
}

.score-bar {
  height: 0.4rem;
  background-color: #e5e7eb;
  border-radius: 0.2rem;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  border-radius: 0.2rem;
  transition: width 0.3s ease;
}

.score-fill.green {
  background-color: #00a708;
}

.score-fill.orange {
  background-color: #f4751b;
}

.commentaire {
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.5;
}

.description-prestataire {
  margin: 1rem 0;
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.4rem;
  border-left: 4px solid #2c3948;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.description-prestataire p:first-child {
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: #2c3948;
  font-size: 1.4rem;
}

.description-text {
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.5;
  white-space: pre-line;
  color: #374151;
}

.commentaire-centralis {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f3f4f6;
  padding: 1rem;
  border-radius: 0.4rem;
}

.commentaire-centralis p {
  color: #2c3948;
  font-size: 1.4rem;
}

.info-circle {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: #2c3948;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: italic;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/composants/DetailsNotesModal/DetailsNotesModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".details-notes-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.details-notes-modal {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 0.8rem;\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.modal-header h2 {\r\n  font-size: 3.2rem;\r\n  color: #2c3948;\r\n  font-weight: 600;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.criteres-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3rem;\r\n}\r\n\r\n.critere-block {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.critere-colone-1 {\r\n  width: 40%;\r\n  padding: 0 2rem 2rem;\r\n}\r\n\r\n.critere-colone-2 {\r\n  width: 60%;\r\n}\r\n\r\n.critere-titre {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.critere-titre h3 {\r\n  color: #2c3948;\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  width: 100%;\r\n}\r\n\r\n.note-container {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.note {\r\n  font-size: 3.6rem;\r\n  font-weight: bold;\r\n  color: #2c3948;\r\n}\r\n\r\n.separator {\r\n  font-size: 2rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.total {\r\n  display: flex;\r\n  gap: 2rem;\r\n  align-items: center;\r\n  font-size: 1.6rem;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n}\r\n\r\n.score-bar {\r\n  height: 0.4rem;\r\n  background-color: #e5e7eb;\r\n  border-radius: 0.2rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.score-fill {\r\n  height: 100%;\r\n  border-radius: 0.2rem;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.score-fill.green {\r\n  background-color: #00a708;\r\n}\r\n\r\n.score-fill.orange {\r\n  background-color: #f4751b;\r\n}\r\n\r\n.commentaire {\r\n  color: #374151;\r\n  font-size: 1.4rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.description-prestataire {\r\n  margin: 1rem 0;\r\n  background-color: #fff;\r\n  padding: 1rem;\r\n  border-radius: 0.4rem;\r\n  border-left: 4px solid #2c3948;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.description-prestataire p:first-child {\r\n  font-weight: bold;\r\n  margin-top: 0;\r\n  margin-bottom: 0.5rem;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.description-text {\r\n  margin: 0;\r\n  font-size: 1.4rem;\r\n  line-height: 1.5;\r\n  white-space: pre-line;\r\n  color: #374151;\r\n}\r\n\r\n.commentaire-centralis {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #f3f4f6;\r\n  padding: 1rem;\r\n  border-radius: 0.4rem;\r\n}\r\n\r\n.commentaire-centralis p {\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.info-circle {\r\n  width: 2.4rem;\r\n  height: 2.4rem;\r\n  border-radius: 50%;\r\n  background-color: #2c3948;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-style: italic;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
